import React from "react";
import { Map, MapCameraChangedEvent, MapMouseEvent } from '@vis.gl/react-google-maps';

export interface MapFullProps extends React.PropsWithChildren<{}> {
  onCameraChanged?: (ev: MapCameraChangedEvent) => void;
  onClick?: (e: MapMouseEvent) => void;
  defaultCenter?: google.maps.LatLngLiteral;
  center?: google.maps.LatLngLiteral;
  defaultZoom?: number;
  zoom?: number;
  height?: number | string;
}

function MapFull(props: MapFullProps) {
  const [mapInitialized, setMapInitialized] = React.useState(false);

  // add one second delay to the map initialization to avoid the map being initialized with the default center and zoom
  React.useEffect(() => {
    setTimeout(() => {
      setMapInitialized(true);
    }, 1000);
  }, [setMapInitialized]);

  return (
    <Map
      defaultZoom={ props.defaultZoom ?? 17 }
      zoom={props.zoom}
      mapTypeId={'hybrid'}
      defaultCenter={ props.defaultCenter ?? {
        lat: 45.1948487,
        lng: 7.8785499,
      }}
      center={props.center}
      gestureHandling={'greedy'}
      disableDefaultUI={true}
      scaleControl={true}
      style={{
        width: '100%',
        height: props.height ?? '100%',
      }}
      onClick={(e) => {
        if (mapInitialized && props.onClick) {
          props.onClick(e);
        }
      }}
      onCameraChanged={(e) => {
        if (mapInitialized && props.onCameraChanged) {
          props.onCameraChanged(e);
        }
      }}
      clickableIcons={false}
      tilt={0}
    >
      { props.children }
    </Map>
  );
}

export default MapFull;
